import { ConfigOptions,getFields, getColumnFieldTitles, getIdFieldName, getTarget, getTargets, getTitleDescriptionField, getFieldSets, getAppContext } from "@urbannex/view-containers";
import { OfbizList, OfbizForm } from "@urbannex/ofbiz-forms";
import { FEATURE_FORMS } from "./forms";
import { NbMenuItem } from "@nebular/theme";

export const configOptions:ConfigOptions = {
    name:"",
    title:"Features",
    listForm:new OfbizList({
      listType:"grid",
      listFormName:"ListProductFeatures",
      listFormLocation:"component://kwikstore/widget/FeatureForms.xml",
      columnFields:getFields("ListProductFeatures",FEATURE_FORMS),
      columnFieldTitles:getColumnFieldTitles("ListProductFeatures",FEATURE_FORMS),
      idFieldName:getIdFieldName("ListProductFeatures",FEATURE_FORMS),
      target:getTarget("ListProductFeatures",FEATURE_FORMS),
      appContext:"catalog",
      remoteFormData:{
        formData:{
          formName:"ListProductFeatures",
          formLocation:"component://kwikstore/widget/FeatureForms.xml",
          listType:"grid",
        }
      },
      emptyListMessage:"No Features found"
    }),
    addForm:new OfbizForm({
      local:true,
      formName:"EditProductFeature",
      formLocation:"component://kwikstore/widget/FeatureForms.xml",
      fields:getFields("EditProductFeature",FEATURE_FORMS),
      appContext:"catalog",
      idFieldName:"productFeatureId",
      targets:getTargets("EditProductFeature",FEATURE_FORMS),
      titleDescriptionField:"description"
    }),
    findForm:undefined,
    settings:[],
    actions:["list","find","add","edit"],
    breadCrumbData:{
      displayPrefix:"Features for ",
      label:"",
      level:2,
      selectedValue:{
        "event":"list",
        "type":"",
        "data":{
          formData:{
            formName:"",
            formLocation:"component://kwikstore/widget/FeatureForms.xml"
          }
        }
      },
      addFormText:"Create Product Feature",
      editFormText:"Update Product Feature"
    },
    relations:[
      {
        title:"Feature Prices",
        addContainerTitle:"Create Feature Price",
        listContainerTitle:"Feature Prices",
        entityName:"ProductFeaturePrice",
        keyMap:{fieldName:"productFeatureId"},
        addFormName:"CreateFeaturePrice",
        listFormName:"ListFeaturePrice",
        addForm: new OfbizForm({
          local:true,
          formName:"CreateFeaturePrice",
          formLocation:"component://kwikstore/widget/FeatureForms.xml",
          fields:getFields("CreateFeaturePrice",FEATURE_FORMS),
          idFieldName:"productFeatureId",
          target:getTarget("CreateFeaturePrice",FEATURE_FORMS),
          titleDescriptionField:getTitleDescriptionField("CreateFeaturePrice",FEATURE_FORMS),
          appContext:"catalog"
        }),
        listForm:new OfbizList({
          listType:"grid",
          listFormName:"ListFeaturePrice",
          listFormLocation:"component://kwikstore/widget/FeatureForms.xml",
          columnFields:getFields("ListFeaturePrice",FEATURE_FORMS),
          columnFieldTitles:getColumnFieldTitles("ListFeaturePrice",FEATURE_FORMS),
          appContext:"catalog",
          remoteFormData:{
            formData:{
              formName:"ListFeaturePrice",
              formLocation:"component://kwikstore/widget/FeatureForms.xml",
              listType:"grid",
            }
          },
          emptyListMessage:"No Prices For This Product Feature.  Use add form to add prices."
        }),
        appContext:"catalog"
      },
      {
        title:"Feature Suppliers",
        addContainerTitle:"Create Feature Supplier",
        listContainerTitle:"Feature Suppliers",
        entityName:"ProductFeaturePrice",
        keyMap:{fieldName:"productFeatureId"},
        addFormName:"CreateSupplierProductFeature",
        listFormName:"EditSupplierProductFeatures",
        addForm: new OfbizForm({
          local:true,
          formName:"CreateSupplierProductFeature",
          formLocation:"component://kwikstore/widget/FeatureForms.xml",
          fields:getFields("CreateSupplierProductFeature",FEATURE_FORMS),
          idFieldName:"productFeatureId",
          target:getTarget("CreateSupplierProductFeature",FEATURE_FORMS),
          titleDescriptionField:getTitleDescriptionField("CreateSupplierProductFeature",FEATURE_FORMS),
          appContext:"catalog"
        }),
        listForm:new OfbizList({
          listType:"grid",
          listFormName:"EditSupplierProductFeatures",
          listFormLocation:"component://kwikstore/widget/FeatureForms.xml",
          columnFields:getFields("EditSupplierProductFeatures",FEATURE_FORMS),
          columnFieldTitles:getColumnFieldTitles("EditSupplierProductFeatures",FEATURE_FORMS),
          appContext:"catalog",
          remoteFormData:{
            formData:{
              formName:"EditSupplierProductFeatures",
              formLocation:"component://kwikstore/widget/FeatureForms.xml",
              listType:"grid",
            }
          },
          emptyListMessage:"No Prices For This Product Feature.  Use add form to add prices."
        }),
        appContext:"catalog"
      }
    ]
  }
  export const baseMenuItems:NbMenuItem[] = [
    {title:"Product Features",group:true},
    {title:"List Product Feature Categories",icon:"list-outline",link:"/admin/features"},
    {title:"New Product Feature",icon:"plus-outline"},
]